var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"stage-parent"},[_c('div',{ref:"stage-container"})])
}
var staticRenderFns = []

export { render, staticRenderFns }